<template>
  <div>
    <div class="admin__row">
      <button class="admin__button--primary button button--primary" v-if="!currentCoupon && !creating" @click="createCoupon">Create Coupon +</button>
    </div>
    <h1 class="admin__title">Coupons ({{ coupons.length }})</h1>
    <form class="section__content form">
      <fieldset v-if="currentCoupon || creating" class="form__group">
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Name of the Coupon</h1>
            <small class="form__item__description">What should we call it?</small>
          </label>

          <section class="admin__input form__item__input input">
            <input type="text" class="input__field"  v-model="name" />
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Coupon Description</h1>
            <small class="form__item__description">How do you describe it what does this coupon do?</small>
          </label>

          <section class="admin__input form__item__input input">
            <textarea type="text" class="input__field"  v-model="description"></textarea>
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Coupon Expiration Date</h1>
            <small class="form__item__description">This is the expiration date of the coupon. After this date the coupon will no longer be able to be used.</small>
          </label>

          <section class="admin__input form__item__input input">
            <input type="date" class="input__field" v-model="expiration_date">
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Single Use?</h1>
            <small class="form__item__description">Can this coupon only be used by one user one time?</small>
          </label>
          <label class="form__item__label">
            <h1 class="form__item__name">{{ getUsedString }}</h1>
            <small class="form__item__description">Was this coupon used already?</small>
          </label>

          <section class="admin__input form__item__input input input__boolean">
            <boolean @input="setSingleUse" :defaultValue="single_use" :id="0"></boolean>
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Plan Selection</h1>
            <small class="form__item__description">This is the plan that the coupon must be used with.</small>
          </label>
          <section class="admin__input form__item__input input">
            <select-input style="padding: 0; height: 100px;" @input="setPlanId" :defaultValue="plan_id" :options="planOptions"></select-input>
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Amount Discounted</h1>
            <small class="form__item__description">This is a number of the amount of money to be taken off of the price enter in US dollars.</small>
          </label>

          <section class="admin__input form__item__input input">
            <input type="number" class="input__field"  v-model="amount_discounted">
          </section>
        </article>
        <h4 v-if="!creating" class="window__title">Active Accounts Using this Coupon ({{ accountsInCoupon ? accountsInCoupon.length : '' }})</h4>
        <article v-if="!creating" v-for="account in accountsInCoupon" class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">{{ account.name }}</h1>
          </label>
        </article>
      </fieldset>
      <fieldset v-if="currentCoupon || creating" class="form__group">
        <article class="form__item form__item--show-border">
          <a href="#" v-on:click.prevent="saveCoupon" class="admin__button--primary section__footer__button button button--primary">Save</a>
          <a href="#" v-on:click.prevent="cancelSaveCoupon" class="admin__button section__footer__button section__footer__button--right button button--secondary">Cancel</a>
          <a href="#" v-if="!creating && currentCoupon" v-on:click.prevent="deleteCoupon" class="admin__button section__footer__button section__footer__button--right button button--remove">Delete Coupon</a>
        </article>
      </fieldset>
      <fieldset class="form__group" v-if="!currentCoupon && !creating">
        <article v-for="coupon in coupons" class="form__category form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name"><strong>{{ coupon.name }}</strong></h1>
          </label>
          <label class="form__item__label">
            <h1 class="form__item__name">Expires: {{ getExpirationDate(coupon.expiration_date) }}</h1>
          </label>
          <label class="form__item__label">
            <p class="export__link link link--small" v-clipboard:copy="generateCouponLink(coupon)" v-clipboard:success="onCopy" v-clipboard:error="onError">Copy Link to Clipboard</p>
          </label>
          <section class="form__item__input input">
            <div @click="editCouponPage(coupon)" class="button button--secondary">Edit Coupon</div>
          </section>
          <section class="form__item__input input">
            <div @click="deliverCoupon(coupon.id)" class="admin__button--primary button button--primary">Deliver Coupon</div>
          </section>
        </article>
      </fieldset>
    </form>
  </div>
</template>

<script>
    import { mapState } from 'vuex';
    import Boolean from '../configurator/Boolean'
    import SelectInput from "../configurator/SelectInput";

    export default {
      name: 'AdminCoupons',
      components: {
        SelectInput,
        Boolean
      },
      data () {
        return {
          currentCoupon: null,
          creating: false,
          name: null,
          description: null,
          expiration_date: null,
          single_use: null,
          plan_id: null,
          amount_discounted: null,
        }
      },
      methods: {
        createCoupon () {
          this.creating = true;
        },
        setSingleUse (val) {
          if (this.currentCoupon) {
            this.single_use = val;
            if (!val) {
              this.used = false;
            } else {
              this.used = this.currentCoupon.used;
            }
          }
        },
        editCouponPage (coupon) {
          this.currentCoupon = coupon;
          this.name = coupon.name;
          this.description = coupon.description;
          this.expiration_date = coupon.expiration_date;
          this.single_use = coupon.single_use;
          this.plan_id = coupon.plan_id;
          this.amount_discounted = coupon.amount_discounted;
          this.used = coupon.used;
        },
        cancelSaveCoupon () {
          this.creating = false;
          this.currentCoupon = null;
          this.name = null;
          this.description = null;
          this.expiration_date = null;
          this.single_use = null;
          this.plan_id = null;
          this.amount_discounted = null;
        },
        getExpirationDate (date) {
          if (new Date(date).getTime() < new Date().getTime()) {
            return 'Expired'
          }
          return date;
        },
        deleteCoupon () {
          if (this.currentCoupon) {
            this.$store.dispatch('coupons/delete', this.currentCoupon.id)
          }
          this.cancelSaveCoupon();
        },
        saveCoupon () {
          let payload = {
            name: this.name,
            description: this.description,
            expiration_date: this.expiration_date,
            single_use: this.single_use,
            plan_id: this.plan_id,
            amount_discounted: this.amount_discounted,
            used: this.used
          };
          if (this.creating) {
            this.$store.dispatch('coupons/create', payload);
          } else {
            this.$store.dispatch('coupons/update', {id: this.currentCoupon.id, payload: payload});
          }
          this.cancelSaveCoupon();
        },
        deliverCoupon (id) {
          this.$modal.show('userinput', {
            modalTitle: 'Deliver Coupon',
            messageText: 'Enter the email of the user you want to deliver this coupon to:',
            fieldType: 'email',
            fieldPlaceholder: 'example@parkave.com',
            buttonText: 'Deliver Coupon',
            callback (value) {
              this.$modal.hide('userinput');
              this.$store.dispatch('coupons/deliver', {id: id, email: value})
            }
          });
        },
        setPlanId (value) {
          this.plan_id = value;
        },
        onCopy () {
          let rootVM = window.rootVM;
          rootVM.$snotify.success('Copied');
        },
        onError (e) {
        },
        generateCouponLink (coupon) {
          return location.origin + '/?coupon=' + coupon.token;
        }
      },
      computed: {
        ...mapState('coupons', ['coupons']),
        ...mapState(['plans']),
        ...mapState('accounts', {
          accounts: 'all'
        }),
        planOptions () {
          let arry = [];
          if (this.plans.length) {
            this.plans.forEach(plan => {
              arry.push({label: plan.name + ' ($' + (plan.price / 100) + ')', value: plan.id})
            })
          }
          return arry;
        },
        getUsedString () {
          if (this.currentCoupon) {
            if (this.currentCoupon.used) {
              return 'Used'
            } else {
              return 'Not Used'
            }
          }
        },
        accountsInCoupon () {
          if (!this.creating) {
            if (this.accounts[0] && this.accounts[0].id) {
              return this.accounts.filter(acct => acct.coupon_id == this.currentCoupon.id)
            }
          }
        }
      }
    }
</script>

<style scoped>
  .input__boolean {
    padding: 10px 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminCoupons.vue